import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", y = 24 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ eyebrow, heading, sub, light = false }) => (
    <FadeUp className="mx-auto max-w-2xl text-center">
        {eyebrow && (
            <p className={`mb-3 text-xs font-semibold uppercase tracking-[0.25em] ${light ? "text-amberct" : "text-royal"}`}>
                {eyebrow}
            </p>
        )}
        <h2 className={`font-display text-3xl font-extrabold tracking-tight sm:text-4xl ${light ? "text-white" : "text-navy"}`}>
            {heading}
        </h2>
        {sub && <p className={`mt-4 text-base sm:text-lg ${light ? "text-slate-300" : "text-slate-600"}`}>{sub}</p>}
    </FadeUp>
);
